module.exports = __webpack_public_path__ + "img/polygon-logo-inverted.e6c7f6d7.svg";